module.exports = __webpack_public_path__ + "static/media/cart.8ee54f7c.png";